import React from 'react'
import {Button, DateTimePicker} from '@therms/atalaya'
import dayjs from 'dayjs'

interface PickReportDateProps {
  actionLabel?: string
  onChangeValue: (date: string) => void
  onComplete: () => void
  value?: string
}

function PickReportDate({
  actionLabel,
  onChangeValue,
  onComplete,
  value,
}: PickReportDateProps) {
  return (
    <div className="gap-y-lg flex flex-col">
      <DateTimePicker
        label="Report Date"
        mode="date"
        onChangeValue={(date) =>
          onChangeValue(dayjs(date).startOf('day').toISOString())
        }
        value={value}
      />

      <div className="inline-flex justify-end">
        <Button onClick={onComplete}>{actionLabel || 'Done'}</Button>
      </div>
    </div>
  )
}

export {PickReportDate}